import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: JSON.parse(localStorage.getItem('cartItems')) || [],
  checkoutData: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const existingItem = state.items.find(
        item =>
          item.ProductId === action.payload.ProductId &&
          item.Color === action.payload.Color &&
          item.Size === action.payload.Size
      );


      let newItems;
      if (existingItem) {
        newItems = state.items.map(item =>
          item.ProductId === action.payload.ProductId &&
          item.Color === action.payload.Color &&
          item.Size === action.payload.Size
            ? {
                ...item,
                quantity: item.quantity + action.payload.quantity,
                Price: action.payload.Price,
                InternationalPrice: action.payload.InternationalPrice,
                OfferPrice: action.payload.OfferPrice,
                InternationalOfferPrice: action.payload.InternationalOfferPrice,
                currentPrice: action.payload.currentPrice,
                isOnSale: action.payload.isOnSale,
                originalPrice: action.payload.originalPrice
              }
            : item
        );
      } else {
        newItems = [...state.items, {
          ...action.payload,
          Price: action.payload.Price,
          InternationalPrice: action.payload.InternationalPrice,
          OfferPrice: action.payload.OfferPrice,
          InternationalOfferPrice: action.payload.InternationalOfferPrice,
          currentPrice: action.payload.currentPrice,
          isOnSale: action.payload.isOnSale,
          originalPrice: action.payload.originalPrice
        }];
      }
      
      localStorage.setItem('cartItems', JSON.stringify(newItems));
      return {
        ...state,
        items: newItems,
      };
    },


    updateQuantity: (state, action) => {
      const { ProductId, Color, Size, quantity } = action.payload;
      const newItems = state.items.map(item =>
        item.ProductId === ProductId && 
        item.Color === Color && 
        item.Size === Size
          ? { ...item, quantity }
          : item
      );
      localStorage.setItem('cartItems', JSON.stringify(newItems));
      return { ...state, items: newItems };
    },


    removeItem: (state, action) => {
      const { ProductId, Color, Size } = action.payload;
      const newItems = state.items.filter(
        item => !(
          item.ProductId === ProductId &&
          item.Color === Color &&
          item.Size === Size
        )
      );
      localStorage.setItem('cartItems', JSON.stringify(newItems));
      return { ...state, items: newItems };
    },


    setCheckoutData: (state, action) => {
      const checkoutData = Array.isArray(action.payload)
        ? action.payload.map(item => ({
            ...item,
            Price: item.Price,
            InternationalPrice: item.InternationalPrice,
            OfferPrice: item.OfferPrice,
            InternationalOfferPrice: item.InternationalOfferPrice,
            currentPrice: item.currentPrice,
            isOnSale: item.isOnSale,
            originalPrice: item.originalPrice
          }))
        : action.payload;
      
      state.checkoutData = checkoutData;
      localStorage.setItem('checkoutData', JSON.stringify(checkoutData));
    },


    clearCart: (state) => {
      state.items = [];
      localStorage.removeItem('cartItems');
    }
  },
});

export const {
  addToCart,
  updateQuantity,
  removeItem,
  setCheckoutData,
  clearCart
} = cartSlice.actions;

export default cartSlice.reducer;